import logo from 'mastodon/../images/logos/logo_dark.png';
import wordmark from 'mastodon/../images/logos/wordmark_dark.png';

export const WordmarkLogo: React.FC = () => (
  <img src={wordmark} alt='Alice in Rose Coffin' className='logo logo--wordmark' />
);

export const SymbolLogo: React.FC = () => (
  <img src={logo} alt='Alice in Rose Coffin' className='logo logo--icon' />
);

// Main app navigation uses the square community logo; auth uses the wordmark.
export const NavigationLogo: React.FC = () => (
  <img src={logo} alt='Alice in Rose Coffin' className='logo logo--wordmark' />
);
